/* eslint-disable */
import * as Types from '../../../../../../generated/graphql'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export type GQLPromoServiceVipLimitsQueryVariables = Types.Exact<{
  [key: string]: never
}>

export type GQLPromoServiceVipLimitsQuery = {
  __typename?: 'Query'
  my: {
    __typename?: 'My'
    messenger: {
      __typename?: 'Messenger'
      limits: { __typename?: 'ChatLimitsType'; vipDailyMaxContacts: number }
    }
  }
}

export const PromoServiceVipLimitsDocument = gql`
  query PromoServiceVipLimits {
    my {
      messenger {
        limits {
          vipDailyMaxContacts
        }
      }
    }
  }
`

/**
 * __usePromoServiceVipLimitsQuery__
 *
 * To run a query within a React component, call `usePromoServiceVipLimitsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromoServiceVipLimitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromoServiceVipLimitsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePromoServiceVipLimitsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GQLPromoServiceVipLimitsQuery,
    GQLPromoServiceVipLimitsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQLPromoServiceVipLimitsQuery,
    GQLPromoServiceVipLimitsQueryVariables
  >(PromoServiceVipLimitsDocument, options)
}
export function usePromoServiceVipLimitsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQLPromoServiceVipLimitsQuery,
    GQLPromoServiceVipLimitsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQLPromoServiceVipLimitsQuery,
    GQLPromoServiceVipLimitsQueryVariables
  >(PromoServiceVipLimitsDocument, options)
}
export function usePromoServiceVipLimitsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQLPromoServiceVipLimitsQuery,
        GQLPromoServiceVipLimitsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQLPromoServiceVipLimitsQuery,
    GQLPromoServiceVipLimitsQueryVariables
  >(PromoServiceVipLimitsDocument, options)
}
export type PromoServiceVipLimitsQueryHookResult = ReturnType<
  typeof usePromoServiceVipLimitsQuery
>
export type PromoServiceVipLimitsLazyQueryHookResult = ReturnType<
  typeof usePromoServiceVipLimitsLazyQuery
>
export type PromoServiceVipLimitsSuspenseQueryHookResult = ReturnType<
  typeof usePromoServiceVipLimitsSuspenseQuery
>
export type PromoServiceVipLimitsQueryResult = Apollo.QueryResult<
  GQLPromoServiceVipLimitsQuery,
  GQLPromoServiceVipLimitsQueryVariables
>
